import { render, staticRenderFns } from "./advanced-search-duration-chip.vue?vue&type=template&id=edfa9efe&"
import script from "./advanced-search-duration-chip.vue?vue&type=script&lang=js&"
export * from "./advanced-search-duration-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports